// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__2uDJD","logo":"Header_logo__3QL_h","notice":"Header_notice__37cC-","button":"Header_button__3V-KY"};